import { FC } from 'react'
import { AtendimentoView } from '../../../atendimento/core/_models'
import { FetchState, useModal } from '../../../../../components'
import { AnotacaoType } from '../../../../../../_metronic/helpers'
import DOMPurify from 'dompurify'

export const AnamneseModal: FC = () => {
  const { fetchStates } = useModal()

  const { data: atendimento } = (fetchStates['atendimento'] || {}) as FetchState<AtendimentoView>

  const formatIndentedHtml = (html: string) => {
    return html.replace(/class="ql-indent-(\d+)"/g, (_, level) => {
      return `style="margin-left: ${parseInt(level) * 20}px;"`
    })
  }

  const anamneses = atendimento?.anotacoes
    ?.filter((anotacao) => anotacao.tipo === AnotacaoType.Anamnese)
    .sort((a, b) => new Date(b.data as string).getTime() - new Date(a.data as string).getTime())

  return (
    <div>
      {anamneses && anamneses.length > 0 ? (
        <div>
          {anamneses.map((anotacao) => (
            <div className='py-2' key={anotacao.data}>
              <span className='fw-bolder'>Nota de {anotacao.dataFormatada}</span>
              <br />
              <div
                className='mt-2'
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(formatIndentedHtml(anotacao?.anotacao as string)),
                }}
              />
            </div>
          ))}
        </div>
      ) : (
        <span>Sem anamnese</span>
      )}
    </div>
  )
}
